import styled from "styled-components"
import Text from "../../atoms/Text";
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const Container = styled.header`
  width: 100%;
  max-width: 600px;
  height: 56px;
  background-color: ${(props) => props.theme.colors.neutral[100]}; 
  border-bottom: 2px solid ${(props) => props.theme.colors.neutral[300]}; 
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 800;
`
const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
`
const AddIcon = styled(AddRoundedIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`
const MainHeader = ({title, variant, onAdd}) => {
  return (
    <Container>
      <Text variant="headline2" weight="medium">
        {title}
      </Text>
      {variant === "action" &&
        <IconButton onClick={onAdd}>
          <AddIcon/>
        </IconButton>
      }
    </Container>
  )
}

export default MainHeader
